<template>
  <v-card>
    <br>
    <v-container>

      <!-- About text -->
      <v-row>
        <v-col>
          <h2>Validation of Acetylcholinesterase Inhibition Machine Learning Models for Multiple Species</h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <p class="about">{{ aboutInfo }}</p>
        </v-col>
      </v-row>

      <!-- Pubication link -->
      <v-row justify="center">
        <v-col cols="4">
          <v-btn block color="deep-purple-lighten-1" height="50px"
            href="https://pubs.acs.org/doi/10.1021/acs.chemrestox.2c00283">Visit publication</v-btn>
        </v-col>
      </v-row>

      <br>

      <!-- Applicability text -->
      <v-row>
        <v-col>
          <h2>Applicability domain</h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <p class="about">{{ applicabilityInfo }}</p>
        </v-col>
      </v-row>

      <br>
    </v-container>
  </v-card>
</template>

<script setup>
const aboutInfo = `Acetylcholinesterase (AChE) is the primary enzyme responsible for hydrolyzing acetylcholine and terminating the signal at neuromuscular junctions and cholinergic synapses. It plays a crucial role in both the brain and nervous system, and is a target for both therapeutics and poisons.

Inhibition of acetylcholinesterase in the brain is one of the few therapeutic strategies available for Alzheimer’s disease. Conversely, inhibition of acetylcholinesterase through organophosphate pesticides is responsible for around three hundred thousand deaths per year. Unsurprisingly, it is a target for both drug discovery and toxicology. As it is also an evolutionarily conserved enzyme, it is also an important topic for ecology regarding pollution.`

const applicabilityInfo = 'The applicability domain (AD) score is calculated based on the reliability-density neighborhood (RDN) method, which considers not only the model overlap but also the individual bias and precision of the overlapping fingerprints. An AD score of 1 indicates that the compound is present in the training set.'
</script>

<style scoped>
/* h2 {

} */

p.about {
  font-size: 1.5rem;
  text-align: left;
  color: white;
  margin-left: 25px;
  margin-right: 25px;
}
</style>
